module.exports = __webpack_public_path__ + "static/media/to-do-list.334ac94c.jpg";